const localStorageKey = '__coffeeTool_token__';

const getToken = () => window.localStorage.getItem(localStorageKey);

const isLoggedIn = () => Boolean(getToken());

const setToken = (tokenId) => {
  window.localStorage.setItem(localStorageKey, tokenId);
};

const clearStorage = () => window.localStorage.clear();

export default {
  setToken,
  getToken,
  isLoggedIn,
  clearStorage,
};
